<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/useful_link/pc_banner_terms.jpeg`)">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          利用規約
        </h1>
        <h2 class="update-time">
          最終更新日：2024年7月26日
        </h2>
        <h3 class="terms-title">
          利用規約と条件：
        </h3>

        <ol class="terms-list">
          <li>
            勝winにご登録のお客様は全員、利用規約に同意する必要がございます。利用規約およびそこで明示的に参照されている文書は、両当事者間の完全な合意および理解を構成し、当サイトとお客様間の契約関係を規定します。当サイトをご利用の前に、これらの利用規約をよく読み、ご理解いただきますようお願いいたします。お客様がこれらの利用規約に同意しない場合は、当サイトを利用しないか、ご利用を継続されないようお願いいたします。また、当サイトのプライバシーポリシーをよくご理解いただいた上でのご利用をお勧めします。<br>
            本ページは勝winの利用規約(以下「利用規約」)を構成しており、当サイトに登録のお客様全員がこれに同意する必要がございます。これらの利用規約およびその中で明示的に参照されている文書は、
            当事者間の合意および理解を構成し、お客様との契約関係を規定します。勝winをご利用の前に、これらの利用規約をよく読んでご理解ください。これらの利用規約に同意しない場合は、当サイトを利用しないか、ご利用を継続されないようお願いいたします。また、当サイトのプライバシーポリシーをよくご理解いただいた上でのご利用をお勧めします。勝winはライセンスを取得しており、コモロ連合アンジュアン自治島政府によって規制されております。
          </li>
          <li>
            勝winは、Initial Singularity Limitedによって所有および運営されております。<br>
            登録番号: 15679 登録住所: Hamchako, Mutsamudu, Autonomous Island of Anjouan Union of
            Comoros.<br>
            勝winはライセンスを取得しており、コモロ連合アンジュアン自治島政府によって規制されており、ライセンス番号:
            15679に基づいて運営されております。勝winはすべての規制遵守条件を満たしており、あらゆる賭けとギャンブルのゲームの運営を行う法的権限を与えられております。
          </li>
          <li>
            これらの利用規約に同意し、当サイトにアカウント(以下「アカウント」といいます。)を登録することにより、お客様へ以下のことを表明および保証いたします。
            <ol class="list-type-lower-alpha">
              <li>
                自身の名前でアカウントを登録します。<br>
                すべてのユーザーアカウント情報など(アカウントナンバーとパスワードを含む)、および/またはサイトを通じてユーザーアカウントにアクセスするその他の方法については、お客様が単独の責任となります。お客様がアカウント侵害の被害にあったと認識された場合は、ただちにサイトに連絡し、アカウントおよびアカウント残高への不正アクセスを防ぐための適切な措置を講じる必要がございます。
              </li>
              <li>お客様が満20歳以上であること。</li>
              <li>
                20歳未満はカジノを利用することが禁じられています。上記の規定に違反していると考えられる場合、アカウントはただちに閉鎖されます。
              </li>
              <li>
                当サイトではお一人につきひとつのアカウントのみ作成できます。
                お客様が何らかの原因で複数のアカウントを開設したまたはしようとした場合、当サイトの裁量により該当のアカウントの一部または全てをブロックまたは終了させる可能性がございます。当サイトを閉鎖し、全ての賭け(決済済みまたは未決済)をキャンセルし、引き出し可能な資金を没収または返金する場合がございます。
              </li>
              <li>
                お客様は、他の誰かの代理などではなく、自分自身の立場でまた自分自身の楽しみと娯楽のためにのみ当サイトを利用する必要がございます。
              </li>
              <li>
                一部の司法管轄地域では、当サイトへのアクセスや利用が違法とみなされる場合がございます。
              </li>
            </ol>
          </li>
          <li>
            勝winは、適用される法律、規制およびその他の規制要件の遵守を含め、利用規約をいつでも変更する権利を有します。などしたがって、当サイトはお客様と勝winとの間の本規約をいつでも変更することができます。<br>
            利用規約に重大な変更があった場合には、サイトに通知を掲載いたします。お客様が改訂された利用規約に同意されない場合、お客様のアカウントを閉鎖いたします。有効なアカウント残高を引き出される場合は、カスタマーサービスにご連絡いただく必要がございます。
          </li>
          <li>
            アカウントを作成するには、携帯電話番号、パスワードなどの個人情報を入力し、登録完了後に名前、生年月日、住所などの個人情報を追加で入力してください。
          </li>
          <li>
            アカウントの名前と住所は身分証明書および関連確認書類と同じである必要があり、身分証明書の住所は住所確認書類と一致している必要がございます。当サイトではお客様の本人確認のため、いつでもお客様に本人確認書類(パスポート、身分証明書、住所確認書類、有効期限内の支払いが可能なクレジットカードなどを含む)の提出をお願いする権利を有します。身分証明書を提出できない場合、当サイトはお客様のアカウントを一時的に閉鎖する権利を有します。
          </li>
          <li>
            ご登録の際は正しい個人情報をご入力いただき、登録情報に変更が生じた場合には随時登録情報を更新していただきますようお願いいたします。上記の行為を行わない場合、アカウントの閉鎖、アカウントの利用制限、入金(ボーナスなどを含む)の無効化などが発生する場合がございます。当サイトは、いつでも理由のいかんにかかわらず、いかなる人物の口座開設を拒否する権利を留保します。
          </li>
          <li>
            VPN、プロキシサーバーなどを利用して実際の位置情報を隠すことは禁止されており、お客様が制限区域から当サイトにアクセスしていると判断した場合、当サイトはお客様への事前通知なく直ちにアカウントを閉鎖する権利を有します。<br>
            禁止地域：お客様が米国およびその領土、マカオ、スイス、アイルランド、シンガポール、ハンガリー、ミャンマー、ルーマニア、ベルギー、デンマーク、フィンランド、ドイツ、イラン、イラク、イタリア、ミクロネシア、ノルウェー、ポーランド、サウジアラビア、オランダ、プエルトリコ、イギリス、フランス、香港、台湾、北朝鮮、イスラエル、キプロス、エストニア、フィリピン、トルコ、スペイン、ブルガリア、アンティグアバーブーダ、キュラソー、法律または地域の条例によってオンラインカジノが禁止されているその他の国にお住まいの場合、勝winはご利用いただくことができません。
          </li>
          <li>
            全てのお客様において、IPアドレスやデバイスごとに登録できるアカウントは1つのみです。また、1世帯につき1アカウントとなります。お客様が複数のアカウントを所持していると当サイトが判断した場合、独自の裁量により、重複したアカウントをブロックまたは閉鎖し、該当アカウントのすべての賭けを無効とする場合があります（決済済みのものを含みます）。さらに、引き出し可能な資金についても没収または返金の対象となります。
          </li>
          <li>
            アカウント情報は登録プロセスの一部であり、お客様は当サイトにログインするためにアカウント番号とパスワードを選択する必要がございます。ログイン情報のセキュリティを保護するのはお客様の責任であり、お客様はご自身のログイン情報を決して他人に開示してはなりません。当サイトは、お客様のログイン情報を第三者への開示など(意図的か非意図的か、積極的か受動的かにかかわらず)による第三者によるアカウントの悪用について責任を負いません。<br>
            お客様のログイン情報を使用して行われるすべての行為は、お客様ご自身の行為とみなされ、そこから生じるすべての責任はお客様が負うものとします。<br>
            お客様のログイン情報が第三者に知られた場合、お客様は責任を持って当サイトに通知し、ログイン情報を変更するものとします。
          </li>
          <li>
            当サイトは、理由を問わずいつでもお客様の身元を確認し、関連書類の提出を要求する権利を有します。これには法律で許可されている身元調査、信用調査、個人履歴調査が含まれますが、これらに限定されません。このような調査の基準は状況によって異なりますが、名前、住所、年齢、職業、金融取引(お客様の財務状況や資金源など)などを含むお客様の登録情報、および/またはお客様のゲーム活動記録などの確認が含まれる場合があります。<br>勝winには、調査が進行中であることをお客様に通知する義務はなく、調査には認可された信用照会機関、身元確認サービス、および/またはお客様を確認するための不正防止機関など、調査を実施するために特定の第三者企業の利用が含まれる場合があります。これらの調査の結果が否定的または不確定の場合、勝winは独自の裁量でお客様のアカウントを閉鎖し、すべての決済済みの賭けをキャンセルし、すべての残高を保留することができます。すべての個人情報は、当サイトのプライバシー
            ポリシーに従って取り扱われます。
          </li>
          <li>
            マネーロンダリングを防止するため、当サイトではすべての支払い取引をチェックしております。勝winおよび規制‧管理機関は、犯罪防止の目的ですべての取引の監視または調査を要求する場合があり、勝winでは疑わしい取引を関連当局に報告します。
            さらに当サイトのゲームに関連して不審な行為を発見した場合、直ちに関連当局に報告し、勝winは適用されるマネーロンダリング防止法およびテロ資金供与対策法に従ってアカウントを凍結または閉鎖、およびすべての決済済みの賭けのキャンセル、および/または口座残高を保留にする場合がございます。
          </li>
          <li>
            お客様はいつでもアカウントにログインし、入金、出金、報酬記録、ゲーム記録などのアカウント履歴を表示することが可能です。エラーを発見された場合、必要に応じて調査および修正できるよう、ただちにサポートに連絡する必要がございます。
          </li>
          <li>
            クレジット、ボーナス、またはその他の資金が誤ってアカウントに入金された場合、お客様はメールまたはチャットを通じて勝winにただちに報告していただきますようお願いいたします。
            誤って入金されたすべての金額は勝winの所有物となり、お客様はご自身のアカウントからただちに勝winに返金する必要がございます。お客様が誤って入金された資金を引き出した場合、お客様は勝winの清算債務者とみなされ、引き出した金額を直ちに返済しなければならず、誤って入金されたポイント、ボーナス、またはその他の資金を使用して行われた賭けは無効になります。
          </li>
          <li>
            12 か月連続で取引活動がない場合、アカウントは休止状態とみなされます。
            アカウントが休止状態になる少なくとも 1
            か月前に、勝winはお客様にメールにて通知を行います。お客様は、アカウントにログインすることでアカウントを再開できます。アカウントが休止状態とみなされた後、勝winがお客様と連絡が取れなかった場合、勝winは、お客様のアカウント残高の5%または管理手数料として月額150円のいずれか高い方を徴収いたします。
            休止アカウントの管理手数料により、残高がゼロになる場合がございます。手数料を返金を求める場合は、口座休止期間中の健康状態不良またはその他の正当な理由を証明する書類を提出する必要がございます。アカウント残高の額面に関わらず利子は発生いたしません。したがって、お客様は勝winを金融機関とは見なすことはできません。
          </li>
          <li>
            勝winはお客様による不正行為や共謀行為などを厳しく禁止します。
            詐欺または共謀行為が発生したと合理的に判断された場合、当サイトは行為の結果として、行われた賭けをキャンセルし、および/またはお客様のアカウント内のすべての資金を没収して閉鎖する権利を留保します。他のお客様が詐欺または共謀行為によって不正な利益を得たと疑う合理的な理由がある場合は、メールまたはチャットを通じて勝winに報告する必要がございます。
          </li>
          <li>
            他のお客様のアカウントへの資金の送金、およびその逆の行為も禁止されております。
          </li>
          <li>
            お客様は、いかなる方法であっても、当サイトに侵入したり、当サイトのコードを変更したりしないこと、また当サイトの抜け穴を悪意を持って利用したり、お客様またはいかなる第三者が当サイトをご利用の際に、ボット、自動機器、機械、電子機器、その他の機器を利用されないことに同意したものとみなします。上記の機器またはお客様に不当な利益を与えるために設計された外部リソースが当サイトで利用されたという合理的な理由が当サイトに発覚した場合、上記の機器によって行われた賭けは全て無効とみなされます。当サイトは独自の裁量により、調査中のアカウントを一時的に凍結または閉鎖する場合がございます。当サイトでは、上記の機器の使用は詐欺に相当するとみなし、この場合、残高を返金せずにアカウントを閉鎖する権利を留保します。
          </li>
          <li>
            勝winは、日本政府または外国政府の要職(PEP
            )に就いているお客様にはサービスを提供いたしません。お客様がいずれかの段階でPEPであると判断された場合、お客様のアカウントは閉鎖されます。当サイトによって行われた
            PEP
            の決定について不服申し立てを行う場合は、メールまたはチャットで当サイトまでお問い合わせください。
          </li>
          <li>
            お客様は、お客様のアカウントからの入出金には、正当な機関によって発行されたお客様ご本人の名前かつ有効なクレジットカードおよびその他の支払い方法のみを使用することに同意したものとみなします。お客様の支払い名義がお客様ご自身のものではないと当サイトが判断した場合、当サイトはお客様のアカウントを閉鎖し、すべての賞金を無効にし、カード会社に発行されたカードの使用を禁止する権利を留保します。
          </li>
          <li>
            お客様は、ご自身のアカウントから資金を引き出す際、任意の金額を入金し、KYC
            本人確認を完了する必要があることに同意します。最低入金額は、当サイト内にあるお客様のアカウントの「入金」ページでご確認いただけます。
          </li>
          <li>
            勝win
            は、引き出しを反映する際にかかる合理的な手数料を請求する権利を留保します。さらに、当サイトでは管理できない追加の外部銀行手数料がかかる場合があり、それらの出金手数料はお客様のアカウントの「出金」ページに表示されます。
          </li>
          <li>
            不正な手段で入手した資金は違法です。適用される法律に従い、勝winは可能な場合、資金移動にお客様と同じキャッシュフローを使用します。入出金は登録されたアカウント所有者の名前でのみ行うことができますが、勝winは強制的に外部との接触を遮断した管理を行うか、お客様に特定の支払方法での資金出金を要求し、出金の取り消しを行う権利を有します。
          </li>
          <li>
            お客様がクレジットカードまたはデビットカードで入金する場合、当サイトはその裁量により、セキュリティコードに加えてカード番号の最初の6桁と最後の4桁を示す両面画像の提供をお客様に要求します。
            (例:CVV)。
          </li>
          <li>
            アカウントから資金を引き出すには、お客様はゲーム内で少なくとも入金額の2倍の最低金額を賭ける必要がございます。勝winは独自の裁量で不十分な賭け金に基づいて出金申請の支払いを拒否し、特定の条件下でお客様に対し、賭け金を上げてプレイするよう要求する権利を有します。
          </li>
          <li>
            無料のベットまたはボーナスは、イベントやプロモーションの一環としてお客様のアカウントに入金される場合がございます。これらの無料ベットやボーナスは当サイト内で利用必要があり、そのまま出金することはできません。<br>
            イベントやプロモーションに応じて、これらの無料ベットとボーナスは、各イベントまたはプロモーションの特定の利用規約を満たすことでリアルマネーと引き換えられる場合がございます。すべてのイベントまたはプロモーションにはボーナスルールと利用規約が適用されます。詳細については、ボーナスルールと利用規約をご覧ください。
          </li>
          <li>
            お客様によるアカウントへの入出金は、金融機関または決済サービス機関を通じて行われます。入出金の手順、利用規約、可用性、手数料、処理時間は、関連する金融機関または決済サービスプロバイダーによって異なる場合がございます。
          </li>
          <li>
            当サイトでは掛売りはできません。アカウントに十分な資金を維持し、それに応じて賭けるのはお客様の責任です。口座残高が不十分な賭け取引は無効となります。お客様のアカウントの資金がすべての賭けをカバーするのに不十分な場合、当サイトは不用意に行われた、または受け入れられた賭けをキャンセルする権利を留保します。清算機関による入金キャンセルによりアカウントの資金が不足した場合、勝winは受付済みのすべての賭けを遡り、当該の賭けからお客様に支払われた資金を払い戻し、無効にする権利を留保します。
          </li>
          <li>
            KYC認証が完了している場合、出金承認は原則として数分程度で完了いたします。
            ※ただし、ゲームプロバイダーのチェックが必要な場合や、提携決済会社のメンテナンス、お客様の受取先口座のメンテナンスなどにより、お時間をいただく場合がございます。
          </li>
          <li>
            お客様のアカウントへの入金は、お客様のゲームプレイに対応している必要があります。当サイトがアカウントの悪用を発見した場合、勝winは独自の裁量でお客様のアカウントを閉鎖し、アカウント内の報酬とアカウント残高を没収する権利を有します。これらの不正利用には、出金リクエストを申請する前に入金額を賭けなかった、または不正な利用などが含まれますが、これらに限定されません。
          </li>
          <li>
            当サイトは、いつでも取引およびゲームの記録を閲覧する権利を有します。再調査後、当サイトは独自の裁量により、不正行為を用いてゲームをプレイされたお客様に対する報酬、ボーナス、リベートを取り消す権利を留保します。
          </li>
          <li>
            お客様が実際のボーナス額を超えるボーナスを獲得するためにイベントまたはプロモーションにおいて不正行為(以下の内容を含む)を行った場合、当サイトはただちにお客様を今後のすべてのイベントまたはプロモーションからの参加権利を剥奪します。
          </li>
          <li>
            ベットにおける禁止事項・全てのルーレットにおいて、一度に25個以上(25を含む)の数字にベットすること。
            <ol class="list-type-lower-alpha">
              <li>全てのゲームにおいて、ベットカバー率が65%を超えた場合</li>
              <li>全てのゲームで、1.5倍以下の配当のベットを繰り返すこと。</li>
              <li>フリースピンを貯め個別に入出金を行って現金を受け取るなどの行為を含むキャンペーンなどへの投機的な参加をすること。上記の行為が発見された場合や、ボーナスや特典などの悪意のある利用が発見された場合は、当サイトは直ちにボーナスおよび特典の権利をはく奪し、アカウントを即時閉鎖する権利を有します。</li>
            </ol>
            現金ウォレット計算方法：<br>
            有効となるベット額は勝利または負けた時のみ計算され、2ティアベット・引き分けの場合は計算されません。<br>
            ゲームに負けた際、ベットした金額が反映されます。 ゲームに勝った際、勝利金がベットした金額の75％以下の場合、勝利金額分が反映され、勝利金がベットした金額の75％以上または同等の場合、ベットした金額が反映されます。<br>
            上記内容はテーブル・ライブゲームおよびクラッシュに適用されます。<br>
            スロット・フィッシングゲームではベットした金額が反映されます。
          </li>
          <li>
            以下の行為が認められた場合の規約と条件：
            <ol class="list-type-lower-alpha">
              <li>第三者への情報の開示</li>
              <li>
                バグ、脆弱性、ハッキング、コンピューター攻撃、その他の不正行為(詐欺)や自動化されたゲーム(ボット)を悪用して、不当な賭けをすること。
              </li>
              <li>
                不正コピーまたは不正利用されたクレジットカードまたはデビッドカードを使用して賭け行為を行う。
              </li>
              <li>ゲーム内において直接または間接的に他のプレイヤーと共謀を図ること。</li>
              <li>当サイトのイベントまたはプロモーションを濫用することを厳格に禁じます。</li>
              <li>
                万が一当サイトで他のプレイヤーとの共謀行為が確認された場合、当サイトは適切な措置を講じる権利を留保し、お客様と他のプレイヤーの損失については責任を負いません。
              </li>
              <li>
                万が一お客様が他のプレイヤーによる共謀行為、詐欺などの犯罪行為を確認された場合、当サイトまでご連絡ください。
              </li>
              <li>
                お客様が当サイトのサービスやソフトウェアを悪用していることが判明した場合、勝winはお客様のアカウントをブロックし、アカウント内の資金を没収する権利を有します。
              </li>
              <li>
                出金条件を満たすためにゲームモードに手を加え、ゲーム構造を悪用しようとしている、または悪意を持って使用されていることが判明した場合、当社はすべてのボーナスと利益を没収するか、お客様のアカウントを直接閉鎖する権利を有します。
              </li>
            </ol>
          </li>
          <li>
            お客様が当サイトで提供されるサービスが娯楽目的のみであることに同意したものとみなします。サービスの利用を強制ではなく、お客様ご自身の判断でサービスを利用するかどうかを選択‧決定することができます。
            したがって、当サイトにアクセスするお客様は、自己の責任においてゲームをプレイする必要がございます。お客様は当サイトにアクセスし、ご自身の名前で娯楽目的で当サイトが提供するサービスを楽しむことに同意したものとみなします。当サイトは、お客様が他の方法で当サイトが提供するサービスを利用することを固く禁じます。
          </li>
          <li>
            勝winは、お客様に事前に通知することなく、独自の裁量により当サイトおよび/または一部のゲームまたはマーケット製品を一時停止、変更、削除、および/または追加する権利、また一時的にまたは永久的に利用停止措置を取る権利を留保し、その結果としてお客様が被ったいかなる損失についても責任を負いません。
          </li>
          <li>
            いかなる理由においても、承認されたゲームラウンドが何らかの理由で中断または終了した場合、すべてのお客様の取引は正確に記録され、ゲームの再開時に未完了のゲームラウンドは途中から再開されます。<br>
            回復が不可能だった場合、勝winはゲームラウンドを削除し、お客様のアカウントに賭け金を返金いたします。
          </li>
          <li>
            勝winが制御不能状態に陥った場合、例：予期しない技術的な問題または第三者事業者による技術的な問題が発生した場合、勝winは賭けをキャンセルまたは返金する場合がございます。またお客様は、コンピューターまたはモバイルデバイスのパフォーマンスとネットワーク接続が当サイトのパフォーマンスと操作に影響を与える可能性があることに同意する必要があり、勝winはお客様の機器、ネットワーク接続、またはサードパーティのプロバイダーによって引き起こされる誤動作や問題についての責任を負いません。<br>
            これらにはゲームをプレイすることができない、または特定のゲームに関連する情報を表示または受信できないことを含みます。
          </li>
          <li>
            勝winは当サイトが完璧にまたはエラーなく機能し、お客様が当サイトおよび当サイトが提供するゲームに中断なくアクセスでき、当サイトとゲームが目的に一致している場合、それらが明示的か黙示的かのいかんに関わらず保証は行わないものとします。
          </li>
          <li>
            当サイトのすべての知的財産権(IP権)は、勝winまたはサードパーティのソフトウェア事業者に帰属します。<br>
            当サイトの利用は、お客様がサイトまたはソフトウェアプロバイダーの知的財産権を所有していることを意味するものではありません。<br>
            知的財産権には、特許、著作権、意匠権、商標、データベース権および上記の権利の応用が含まれます。また、著作者の人格権、専有技術、企業秘密、機密情報、ドメイン名、URL商号およびその他すべての知的財産権
            (およびそれに関連するライセンス)が含まれています。<br>
            これらには登録されているかどうか、登録可能かどうか、特定の国や地域、または世界の他の場所に居住しているかどうかが含まれますが、これらに限定されません。
          </li>
          <li>
            お客様は適用される法律の範囲で、次のことを行ってはなりません:
            <ol class="list-type-lower-alpha">
              <li>
                ソフトウェアおよび/または当サイトのコピー、配布、公開、リバースエンジニアリング、逆コンパイル、逆アセンブル、変更、変換、翻訳、またはその他の方法でデコードすること、またはソフトウェアおよび/またはサイトのソースコードから二次的著作物を作成するためにソースコードを取得しようとすること。
              </li>
              <li>
                ソフトウェアおよび/または当サイト、またはその一部から著作権、所有権、または同様の通知を削除すること。
              </li>
              <li>
                ソフトウェアの販売、譲渡、サブライセンス、譲渡、頒布またはリースすること。
              </li>
              <li>
                コンピュータネットワークまたはその他の手段を介してソフトウェアを第三者に提供すること。
              </li>
              <li>ソフトウェアを物理的または電子的な方法で任意の国に輸出すること。</li>
              <li>
                適用される法律または規制で禁止されている方法でソフトウェアを使用すること。
              </li>
              <li>
                知的財産権に損害を与える、または損害を与える可能性のある行為、またはInitial
                Singularity
                Limited社、その従業員、取締役、役員、コンサルタントのイメージや評判を傷つける行為。
              </li>
              <li>
                本規約で明示的に許可されていない方法で、ソフトウェアおよび/または当サイト、またはその一部を使用する。
              </li>
            </ol>
          </li>
          <li>
            お客様は、当サイトまたはゲーム内でプレイヤーが使用する名前や画像(プレイヤーのアカウントなど)が第三者の知的財産権、プライバシー、その他の権利を侵害しないこと、また他人に不快感を与えないこと
            。<br>
            当サイトのプライバシー
            ポリシーの条項に従って、当サイトまたはゲームに関連するあらゆる目的で使用するために、お客様はそれらの名前や画像の、取消不能、譲渡可能、ロイヤルティフリー、およびサブライセンスの許可の権利を勝winに付与します。
          </li>
          <li>
            お客様が当サイトのサービスに関してご意見などございましたら、当サイトの指示に従ってカスタマーサービスチームに連絡いただくか、support@katsuwin.ai 宛にメールをご送付ください。<br>
            特定のゲームに関するご意見、お問い合わせは、問題が発生してから 7
            営業日以内に行う必要がございます。
            支払い、アカウントの停止、ボーナスの計算に関してはこれらに限定されないものといたします。<br>
            その他の事項に関しては、問題が発生してから 1
            か月以内にご連絡いただく必要がございます。<br>
            ご意見、お問い合わせに関してはカスタマーサービスチームがご対応いたします。カスタマーサービススタッフが問題をすぐに解決できない場合は、勝winの内部担当者が対応し、お客様には現在のお問い合わせ状況を適切にお知らせいたします。<br>
            当サイトでは、通常14営業日以内に問題を解決するために最善を尽くします。
          </li>
          <li>
            お客様はカスタマーサービスに連絡し、いつでもアカウントを閉鎖し、利用可能な残高を引き出すことができます。<br>
            お客様のアカウントの残高がマイナスの場合は、ただちに当サイトにお支払い手続きをしていただく必要がございます。お客様のアカウントは、全額返金された場合にのみ閉鎖できます。アカウント閉鎖時にアカウントに未決済の賭け金がある場合、それらは有効とみなされ
            (当サイトの利用規約に従ってキャンセル/無効化される場合を除く)、お客様は当サイトにご連絡いただきますと、結果として得られた賞金を回収することができます。<br>
            (当サイトが利用規約に従い賞金の全部または一部を留保する権利を留保しないことに限定いたします)
          </li>
          <li>
            当サイトは以下の事案が発生した場合、説明なしにお客様のアカウントを一時停止または終了し、お客様が行った賭けを取り消し、アカウントから賞金を削除し、および/または当サイトが適切とみなすその他の措置を講じる権利を留保します。<br>
            お客様とのビジネス関係を維持し続けることが、当サイトのライセンスおよび一般的な規制上の義務、または当サイトのサービスに悪影響を与える可能性があると当サイトが判断した場合。<br>
            お客様が当サイトにおいて違法または詐欺行為に値する行為をされた場合。<br>
            お客様がギャンブル禁止地域に在住、または禁止地域で当サイトのゲームをご利用いただいた場合。<br>
            お客様がいかなる利用規約に違反された場合。<br>
            法律または当サイトの第三者ライセンス許諾者により、当サイトに措置を講じるよう命じられた場合。
            <ol class="list-type-lower-alpha">
              <li>
                本規約の第12条に記載されている理由により、当サイトがお客様のアカウントを終了した場合、お客様がこれらの規約および利用規則を遵守していれば、当サイトはお客様がその時点で保有している議論の余地のないアカウント残高を返金します。<br>
                法律で認められる最大限の範囲で、当サイトはお客様に対して一切の責任を負いません。<br>
                上述の内容は適切な状況において、お客様に対して法的措置を講じる当ウェブサイトの権利を排除するものではございません
              </li>
            </ol>
          </li>
          <li>
            如何なる場所において、勝winに関わる全ての者へ対して攻撃的、誹謗中傷、侮辱するような発言、その他不快な内容の発言や行動をされた場合は、当サイトの権限によりお客様のアカウントを停止または制限する可能性がございます。また、引き続きチャットやメールのお返事を中止することがございます。
          </li>
          <li>
            プレイヤーが当ウェブサイトを通じて賞金を獲得された場合、勝winは宣伝活動およびプロモーションを目的として、お客様のユーザー名をご提供いただくことにご同意いただいたものとみなします。
          </li>
          <li>
            勝winではマネーロンダリング等防止のため、必要に応じて「収入を証明する書類」の提出を求める場合がございます。
          </li>
        </ol>

        <h1 class="main-title">
          責任あるギャンブル
        </h1>

        <ol class="terms-list">
          <li>
            ほとんどのお客様にとってギャンブルは娯楽、楽しみ、刺激を意味しますが、一部のお客様にとってはギャンブルがマイナスの影響を与えることも認識されております。
            医学的観点から見ると、ギャンブル依存症は以前から深刻な問題であると捉えられております。<br>
            当サイトでは運営当初からこのことを考慮し、全力でサポートしていく所存でございます。
            「責任あるギャンブル」では、ギャンブル提供者が多段階の対策を通じてマイナスの影響を引き起こす可能性を軽減できることを理解しており、マイナスの影響が生じた場合には、積極的にそれに対抗する措置を講じるよう努めます。<br>
            ギャンブルへのマイナスの影響に対抗するための最も重要なことは、ギャンブルのリスクについての理解と教育、そしてお客様がマイナスの影響に陥らないように自制するようサポートすることです。
          </li>
          <li>
            ギャンブルを楽しみ、マイナスの影響が生じることを避けるために、ギャンブルをする前に次のことを考慮することをお勧めいたします。
            入金限度額を設定する
            ギャンブルを始める前に、自分の経済状況に基づいてギャンブルにどれだけの金額を賭けることができるかを検討してください。
            ギャンブルはお客様の娯楽の為にございます。<br>
            一切を惜しまず損失を取り戻そうとしないこと。
            大きなリスクを冒さず、どんな犠牲を払ってでも以前の損失を取り戻そうとしないでください。
            ギャンブルは楽しむためのものであり、お金を稼ぐためのものではありません。<br>
            <br>
            制限時間を設定する<br>
            制限時間を設定し、それを守るようにしてください。
            ギャンブルだけがあなたの趣味ではありません。ギャンブルと他の趣味のバランスを見つけることを心がけてください。
            <br>
            <br>
            賢く遊ぶ<br>
            極度に緊張しているとき、落ち込んでいるとき、または極度のストレスにさらされているときは、ギャンブルをしないことを選択するのが賢明です。
            <br>
            <br>
            休息<br>
            疲労が溜まっている時または集中力が低下している際は、休息を取るようにしてください。
            <br>
            <br>
            アカウントは1つのみ作成<br>
            ギャンブルにどれだけの時間とお金を費やしているかを把握するために、複数のアカウントを作成することを禁止いたします。
          </li>
        </ol>
      </div>
    <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    footerIframe() {
      return 'https://katsuwin.info/iframe/term-of-service'
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
